import React from "react";
import "./ActivityHeader.css";

export default function ActivityHeader({ children }) {
  return <div className="activity-header">{children}</div>;
}
